import DiscountTable from 'components/receipt/commons/ListItemBox/DiscountTable'
import ItemTable from 'components/receipt/commons/ListItemBox/ItemTable'
import RewardRedemptionInfo from 'components/receipt/commons/ListItemBox/RewardRedemptionInfo'
import {rupiah} from 'utils/formatter'
import styles from './ListItemBox.css'

class ListItemBox extends React.Component {
  render () {
    let {paymentDetail} = this.props
    let {loyalty} = paymentDetail
    // noinspection JSUnresolvedVariable
    return (paymentDetail.checkouts.length > 0) && <div className={styles['list-item-box']}>
      <ItemTable checkouts={paymentDetail.checkouts} checkoutPriceFormatter={rupiah} />
      <DiscountTable discounts={paymentDetail.payment_discounts} />
      {loyalty && loyalty.redemption && loyalty.redemption.reward &&
        <RewardRedemptionInfo redeemReward={loyalty.redemption.reward} totalRedeemAmount={paymentDetail.total_redeem_amount} />}
      </div>
  }
}

ListItemBox.propTypes = {
  paymentDetail: React.PropTypes.object
}

export default ListItemBox



// WEBPACK FOOTER //
// ./app/components/receipt/transactions/ListItemBox/ListItemBox.js